module.exports = __webpack_public_path__ + "img/healthy_page05_img3.99192ac8.png";